<wiz-hgroup width="100%" height="100%" verticalAlign='center' style="padding: 5px;">
    <span
    #blockBack
    [style.backgroundColor]="color"
    width="10px"
    height="10px"
    class="scen-round-mark"
    ></span>
    <wiz-label
    [wizLabel]="code"
    [wizTextBehavior]="'truncate'"
    [wizTooltip]="trsLabel"
    ></wiz-label><!--[visible]="showScenLabel"-->
</wiz-hgroup>